import { apiAuth, apiResponseType } from ".";

export const getEmployeeSalaryHistories = (employeeId: number) =>
  apiAuth.get(`employee-salary-histories?employee_id=${employeeId}`) as apiResponseType;

export const createEmployeeSalaryHistory = (data) =>
  apiAuth.post("/employee-salary-histories/store", data) as apiResponseType;

export const updateEmployeeSalaryHistory = (uuid: string, data) =>
  apiAuth.post(`employee-salary-histories/${uuid}/update`, data) as apiResponseType;

export const deleteEmployeeSalaryHistory = (uuid: string) =>
  apiAuth.delete(`employee-salary-histories/${uuid}/destroy`) as apiResponseType;
